/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowsSplit = createReactComponent("outline", "arrows-split", "IconArrowsSplit", [["path", { "d": "M21 17h-8l-3.5 -5h-6.5", "key": "svg-0" }], ["path", { "d": "M21 7h-8l-3.495 5", "key": "svg-1" }], ["path", { "d": "M18 10l3 -3l-3 -3", "key": "svg-2" }], ["path", { "d": "M18 20l3 -3l-3 -3", "key": "svg-3" }]]);

export { IconArrowsSplit as default };
//# sourceMappingURL=IconArrowsSplit.mjs.map
